import React from 'react';

function Home() {
  return (
    <div id="main" className="wrapper">
      <div className="inner">
        <header className="page-header">
          <h1>Legal Policies</h1>
          <p>Thanks for taking the time to learn about Reliance Litigation's legal policies.</p>
        </header>
        <h2>About This Website</h2>
        <p>This dedicated website is where you'll find information about our <a href="/terms">Terms Of Service</a>, <a href="/privacy">Privacy Policy</a>, and <a href="/cookie">Cookie Policy</a>.</p>
        {/* <!-- and in addition learn about what you can and can't do with our websites or third parties marketing partners --> */}
        <h2>We Care About Your Privacy</h2>
        <p>We have made it simple for you to request to opt-out of our marketing list or campaigns by filling out our <a href="/opt-out">Opt-Out Request</a> form.</p>
        <h2>What information we collect</h2>
        <p>We collect information about you when you use the Reliance Litigation websites or third-party marketing partner websites. This information includes registration details, personal identifiers and your service preferences. To find out more about Cookies and how to alter or remove your Cookie settings, visit <a href="https://www.allaboutcookies.org" title="All About Computer Cookies - Session Cookies, Persistent Cookies,How to Enable/Disable/Manage Cookies" target="_blank" rel="noopener noreferrer">AllAboutCookies.org</a>. We may supplement the information we collect with information from third parties, for example if you link to us from a social media platform.</p>
        <div> </div>
        {/* Privacy Control */}
        <div className="features" style={{display: 'none'}}>
          <div className="feature">
            <header className="heading">
              <h2>Request a copy of your data</h2>
            </header>
            <ul className="actions special">
              <li><a href="/opt-out" className="button primary">Learn More</a></li>
            </ul>
          </div>
          <div className="feature">
            <header className="heading">
              <h2>Delete your data</h2>
            </header>
            <ul className="actions special">
              <li><a href="/opt-out" className="button primary">Learn More</a></li>
            </ul>
          </div>
        </div>
      </div>
  </div>
  );
}

export default Home;
